import { useState } from 'react';

type ScheduleType = 'weekdays' | 'weekends';

export default function Toggle() {
  const [selected, setSelected] = useState<ScheduleType>('weekends');

  return (
   <div className="relative inline-flex bg-gray-50 rounded-lg border border-black border-[2px] overflow-visible p-0.5 shadow-[4px_4px_0_0_rgba(0,0,0,100)]">
      <button
        onClick={() => setSelected('weekends')}
        className={`
          relative px-6 py-2.5 text-sm font-semibold
          transition-all duration-300 ease-out
          rounded-md
          ${selected === 'weekends'
            ? 'text-black shadow-sm'
            : 'text-gray-700 hover:text-gray-900'
          }
        `}
      >
        <span className="relative z-10">Evenings & Weekends</span>

        <div
          className="absolute -top-4 left-1/2 -translate-x-1/2 bg-red-500 text-white text-[10px] font-bold px-2.5 py-0.5 rounded whitespace-nowrap shadow-md z-20"
        >
          Most Popular
        </div>

        {selected === 'weekends' && (
          <div
            className="absolute inset-0 bg-teamcare-yellow rounded-md animate-slide-in shadow-sm"
          />
        )}
      </button>
       <button
        onClick={() => setSelected('weekdays')}
        className={`
          relative px-6 py-2.5 text-sm font-semibold
          transition-all duration-300 ease-out
          rounded-md
          ${selected === 'weekdays'
            ? 'text-black shadow-sm'
            : 'text-gray-700 hover:text-gray-900'
          }
        `}
      >
        <span className="relative z-10">Weekdays</span>

        {selected === 'weekdays' && (
          <div
            className="absolute inset-0  bg-teamcare-yellow rounded-md animate-slide-in shadow-sm"
          />
        )}
      </button>
    </div>
  );
}
